import { useEffect, useState } from "react";

// DEBOUNCED INPUT - ONE OF THE HUMAN-VISIBLE USES OF `setTimeout` THE REPO RULES
// ALLOW. 300MS MATCHES PRIMENG `p-autoComplete`'S DEFAULT `delay`.
export function useDebouncedValue<T>(value: T, ms = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return debounced;
}
